import { openModal } from '@core/components/ModalStack';

export async function openTestTicketModal() {
  const { TestTicketModal } = await import('./TestTicketModal');

  openModal(TestTicketModal, {});
}
